import { render, staticRenderFns } from "./TableTwo.vue?vue&type=template&id=2b73f462&scoped=true&"
import script from "./TableTwo.vue?vue&type=script&lang=js&"
export * from "./TableTwo.vue?vue&type=script&lang=js&"
import style0 from "./TableTwo.vue?vue&type=style&index=0&id=2b73f462&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b73f462",
  null
  
)

export default component.exports